import { Dmlanhdao } from './dmlanhdao';
import { Donvi } from './donvi';

export class Quanlylichhop {
  id: number;
  loai: number;
  ngay: Date;
  thoigianid: number;
  thoigian: string;
  hoten: string;
  chucvuid: number;
  noidung: string;
  taptin: string;
  hienthi: number;
  dmdonvi: Donvi;
  dmdonviid: number;
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;
  dmlanhdao: Dmlanhdao;
  thu : number;
  lanhdaoid: number;  
}